import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import './InProgress.css';

const InProgress = ({ count = 0 }) => {
    return (
        <div className="inprogress-card">
            <div className="inprogress-header">
                <span className="inprogress-title">In Progress</span>
                <FontAwesomeIcon icon={faSpinner} className="inprogress-icon" spin />
            </div>
            <span className="inprogress-count">{count}</span>
        </div>
    );
};

export default InProgress;
